import { FulfillmentOrderLineItem } from "@redotech/redo-model/fulfillments/fulfillment-order-line-item";
import { Input } from "@redotech/ui/form";
import { ImmutableCountMap } from "@redotech/util/map";
import { Dispatch, SetStateAction } from "react";

export enum ScanningModal {
  FULFILLMENT_GROUP_SELECTION = "FULFILLMENT_GROUP_SELECTION",
  TOTE_ORDER_SELECTION = "TOTE_ORDER_SELECTION",
  CLOSED_GROUP_WARNING = "CLOSED_GROUP_WARNING",
  INCOMPLETE_VERIFICATION = "INCOMPLETE_VERIFICATION",
  PARTIAL_FULFILL = "PARTIAL_FULFILL",
  WRONG_BARCODE = "WRONG_BARCODE",
  DUPLICATE_BARCODE = "DUPLICATE_BARCODE",
  MERGED_PACKING_SLIP_SCANNED = "MERGED_PACKING_SLIP_SCANNED",
  MULTI_TOTE_VERIFICATION = "MULTI_TOTE_VERIFICATION",
  LEAVE_SINGLE_ITEM_PICK_SESSION = "LEAVE_SINGLE_ITEM_PICK_SESSION",
  PROBLEM_ORDER_WARNING = "PROBLEM_ORDER_WARNING",
  MERGE_ADDRESS_SELECTION = "MERGE_ADDRESS_SELECTION",
  BIN_SOURCE_SELECTION = "BIN_SOURCE_SELECTION",
}

export interface MultiToteVerificationData {
  toteIds: string[];
  toteNames: Record<string, string>;
  toteBarcodes: Record<string, string>;
  scannedToteId: string;
  fulfillmentGroupId: string;
}

export interface UseScanningLogicResult {
  handleActionButtonClick: () => void;
  handleScan: (barcode: Input<string>) => void;
  pending: boolean;
  setFulfillmentActionButton: Dispatch<
    SetStateAction<HTMLButtonElement | null>
  >;
  handlePartialFulfill: () => void;
  doPartialFulfill: (data: any) => void;
  partialFulfillPending: boolean;
  handleNavigate: (value: string, scanOnLoad?: string) => Promise<void>;
}

export type Scanned = ImmutableCountMap<string>;

export type ScanRow = FulfillmentOrderLineItem & {
  rowKey: string;
  rowIndex?: number;
};
